import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	"components": {
		"app": {
			"gridProps": {
				"breakpoints": [
					{
						"modifier": "up",
						"props": {
							"grid": {
								"rows": [
									{
										"columns": [
											{
												"components": [
													{
														"key": "base.applicationEmbed",
														"props": {
															"applicationCode": "ba046640-fdd3-4790-9320-2aa25b5201e1",
															"hostname": "https://api-rel.fundpress.io/",
															"templateId": "ksys-app-key-facts",
														}
													},
													{
														"key": "base.applicationEmbed",
														"props": {
															"applicationCode": "98471e25-b0b7-445f-b10b-2bbbec509430",
															"hostname": "https://api-rel.fundpress.io/",
															"templateId": "ksys-app-commentary"
														}
													},
												]
											}
										]
									},
									{
										"columns": [
											{
												"components": [
													{
														"key": "base.applicationEmbed",
														"props": {
															"applicationCode": "177ee076-42ec-40aa-8e49-941dfbe36bc9",
															"hostname": "https://api-rel.fundpress.io/",
															"templateId": "ksys-app-fact-list"
														}
													},
												]
											}
										]
									},
									{
										"columns": [
											{
												"components": [
													{
														"key": "base.applicationEmbed",
														"props": {
															"applicationCode": "488f18d3-113c-4e37-b184-bc8f37303624",
															"hostname": "https://api-rel.fundpress.io/",
															"templateId": "ksys-app-line-chart"
														}
													},
												]
											}
										]
									},
								]
							}
						},
						"size": "xsmall"
					}
				]
			}
		}
	}
};
